module.exports = __webpack_public_path__ + "static/media/TeachOne_Share.df108f1c.png";